module.exports = __webpack_public_path__ + "img/pos-icon-active.00182716.svg";